import React from 'react';
import { useFocusedWorkspaceSelector } from '../../features/home/hooks/use-view';
import { useAppDispatch, useAppSelector } from '../../hooks/store-hooks';
import { workspaceSwitchView } from '../../state/slices/workspace-slice';
import { Command } from './types';

export function useViewCommands(): Command[] {
    const dispatch = useAppDispatch();
    const views = useAppSelector((x) => x.views.items);
    const focusedWorkspaceId = useAppSelector((x) => x.workspace.selectedId);
    const selectedViewId = useFocusedWorkspaceSelector((x) => x.view.id);

    return React.useMemo<Command[]>(
        () =>
            views.map((view) => ({
                id: `view-${view.id || 'default'}`,
                title: `Switch to view: ${view.name}${view.id === selectedViewId ? ' (current)' : ''}`,
                keywords: ['view', 'switch', view.name],
                group: 'Views',
                run: () => dispatch(workspaceSwitchView({ workspaceId: focusedWorkspaceId, view }))
            })),
        [views, selectedViewId, focusedWorkspaceId, dispatch]
    );
}
